import photo1 from './project16-1.png';
import photo2 from './project16-2.png';

const project16 = {
  id: 16,
  name: '도장깨기',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '정연주 박서연 이가은',
    },
    {
      position: 'BackEnd Developer',
      names: '문서영 정유진 손민서 황혜진',
    },
    {
      position: 'UXUI Designer',
      names: '박시은',
    },
  ],
  about:
    '매일 똑같은 일상 속에서 벗어나고 싶은 사람들을 위해 다양한 테마별로 장소를 추천하는 사이트 입니다. 스포츠, 이색취미, 힐링 등 다양한 분야의 장소를 추천하여 어디로 놀러갈지 고민하는 사람들에게 도움이 될 수 있는 유용한 사이트가 될 것입니다. 또한 해당 장소를 추천 받아 방문한 사람들은 어플에 사진과 글을 업로드하며 댓글을 남기는 등 그들만의 프라이빗한 기록을 공유할 수 있습니다.',
  links: {
    website: '',
    github: 'https://github.com/dojang-crush',
  },
  photos: [photo1, photo2],
};

export default project16;
